import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const DetailDrawer = styled.div`
  width: 22rem;
  flex-shrink: 0;
  max-height: 70vh;
  background: ${tokens.surface.raised};
  padding: 1.5rem;
  overflow-y: auto;
  border-radius: 0.75rem;
  border: 1px solid ${tokens.border.hairline};
`

export const NodeRowInner = styled.div<{ $selected?: boolean; $depth: number }>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.625rem;
  padding-left: ${(props) => 0.625 + props.$depth * 1.375}rem;
  border-radius: 0.625rem;
  cursor: pointer;
  background: ${(props) => (props.$selected ? tokens.accent.soft : 'transparent')};
  border-bottom: 1px solid ${tokens.border.hairline};

  &:hover {
    background: ${(props) => (props.$selected ? tokens.accent.soft : tokens.surface.raised)};
  }
`

export const ChevronSlot = styled.span`
  width: 1rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 0.875rem;
    height: 0.875rem;
    fill: ${tokens.text.secondary};
  }
`

export const DrawModeBar = styled.div`
  width: 100%;
  border: 1px solid ${tokens.border.hairline};
  background: ${tokens.surface.raised};
  border-radius: 0.75rem;
  padding: 0.75rem 1rem;
  margin-top: 1rem;
`

export const WarnBox = styled.div`
  border: 1px solid ${tokens.accent.soft};
  background: ${tokens.accent.soft};
  border-radius: 0.625rem;
  padding: 0.625rem 0.75rem;
  font-size: 0.8125rem;
  color: ${tokens.accent.base};
  margin: 0.625rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const SectionLabel = styled.div`
  font-size: 0.6875rem;
  color: ${tokens.text.secondary};
  margin: 1rem 0 0.375rem;
  letter-spacing: 0.06rem;
  text-transform: uppercase;
`

export const AttrRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.4375rem 0;
  border-bottom: 1px solid ${tokens.border.hairline};
  font-size: 0.8125rem;
`

export const ModuleBindingRow = styled.div`
  display: flex;
  gap: 0.5rem;
  padding: 0.4375rem 0;
  border-bottom: 1px solid ${tokens.border.hairline};
  font-size: 0.78125rem;
`

export const MapContainer = styled.div`
  width: 100%;
`

export const MapLayout = styled.div`
  display: flex;
  gap: 1rem;
  align-items: stretch;
  width: 100%;
`

export const MapColumn = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`

export const LocationsMapContainer = styled.div`
  width: 100%;
  height: 32rem;
  border-radius: 0.75rem;
  background-color: ${tokens.surface.base};
  border: 1px solid ${tokens.border.hairline};
  overflow: hidden;
`

export const LocationsMapLoading = styled.div`
  width: 100%;
  height: 32rem;
  border-radius: 0.75rem;
  background-color: ${tokens.surface.base};
  border: 1px solid ${tokens.border.hairline};
  display: flex;
  align-items: center;
  justify-content: center;
`

export const MapDrawSidebar = styled.div`
  width: 14rem;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem;
  border-radius: 0.75rem;
  border: 1px solid ${tokens.border.hairline};
  background: ${tokens.surface.raised};
`

export const LegendRow = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
  flex-wrap: wrap;
`

export const LegendDot = styled.span<{ $color: string }>`
  color: ${(props) => props.$color};
`

export const RegistryFooter = styled.div`
  display: flex;
  gap: 0.875rem;
  margin-top: 0.625rem;
  flex-wrap: wrap;
`


